export const setCookie = (name, value, days = null, path = '/', domain = null, secure = false) => {
  let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    cookieString += `; expires=${date.toUTCString()}`;
  }
  cookieString += `; path=${path}`;
  if (domain) {
    cookieString += `; domain=${domain}`;
  }
  if (secure) {
    cookieString += '; secure';
  }
  document.cookie = cookieString;
};

// 获取Cookie的方法
export const getCookie = (name) => {
  const nameEQ = `${encodeURIComponent(name)}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
    }
  }
  return null;
};

export function getTopLevelDomain() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  // ip直接返回
  if (/^\d+(\.\d+){3}$/.test(hostname)) {
    return hostname;
  }

  // 有些顶级域名如.co.uk 需要引入映射表库，暂时不考虑
  return parts.slice(-2).join('.');
}

export const getAllCookies = () => {
  // 获取所有cookie
  let cookies = document.cookie;

  // 将cookie字符串拆分为数组
  let cookiesArray = cookies.split('; ');

  // 创建一个对象来存储每个cookie
  let cookiesObject = {};

  // 遍历每个cookie并将其添加到对象中
  cookiesArray.forEach((cookie) => {
    let [name, value] = cookie.split('=');
    cookiesObject[name] = value;
  });

  return cookiesObject;
};

const cookie = {
  setCookie,
  getCookie
};

export default cookie;
